export default "__VITE_ASSET__DDW$zZ12__"